import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import { ButtonLoading, InputV2, Icons } from 'components';
import { makeStyles } from '@mui/styles';
import UploadFiles from '../UploadFile';

const useStyles = makeStyles((theme) => {
  return {
    dialogMain: {
      '& .MuiDialog-paper': {
        borderRadius: '10px',
        overflowY: 'inherit',
      },
      '& .MuiDialogContent-root': {
        overflowY: 'auto',
        '&::scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-moz-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '0',
          minWidth: '0',
        },
        '&.noneOverFlow': {
          overflowY: 'inherit',
        },
      },
      '& .MuiDialogActions-root': {
        justifyContent: 'flex-start',
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '20px',
        gap: '15px',
      },
      '& .MuiDialog-container': {
        width: '100vw',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
    },
    dialogTitle: {
      margin: 0,
      padding: '20px',
      borderBottom: '1px solid #E2E5E9',

      '& h2': {
        fontSize: 16,
        color: '#0C0E10',
      },
    },

    titleText: {
      fontSize: 12,
      marginInlineStart: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      //fontWeight: 'bold',
    },

    chkItem: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: '#f4f4f4',
      borderRadius: '8px',
      fontSize: '12px',

      border: '2px solid #f4f4f4',
      alignItems: 'center',
      padding: '2px 12px',
      margin: '4px 0',
      transitionDuration: '200ms',
      '&:hover': {
        //marginRight: '4px',
        marginLeft: '4px',
        transitionDuration: '200ms',
      },
    },
    activeItem: {
      border: '2px solid #449cc9',
      //border: '2px solid #2B3990',
    },
    colorActive: {
      color: '#2B3990',
      fontWeight: 'bold',
    },
    colorActivePlace: {
      opacity: '1',
    },
    colorPlace: {
      opacity: '0.3',
      fontWeight: 'bold',
    },
    customClassdialogContent: {
      minWidth: '440px',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(0.75),
      color: theme.palette.grey[500],
    },

    bulkFileTitle: {
      fontWeight: 500,
      color: theme.palette.grey[700],
      marginTop: theme.spacing(2),
      '& a': {
        fontSize: 11,
        color: theme.palette.primary.main,
        background: theme.palette.primary.light,
        padding: theme.spacing(0.5, 1.5),
        borderRadius: 20,
      },
    },
    inpuTitleOther: {
      marginTop: '24px',
      '& input': {
        padding: '15px !important',
      },
    },
    dialog: {},
    content: {
      minHeight: '240px !important',
      maxHeight: '400px',
      overflowY: 'auto',
    },
  };
});
const UploadFileDg = (props) => {
  const { isOpenDg, setIsOpenDg, data, level, typeDg, setData, setUploaded, isEditPage =  false } = props;
  const [inputValue, setInputValue] = useState('');
  const classes = useStyles();
  const [fileUploaded, setFilesUpoaded] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [acceptsFile, setAcceptFiles] = useState({
    0: '.png, .pdf, .zip, .rar, .jpg, .jpeg,',
    1: '.png, .pdf, .zip, .rar, .jpg, .jpeg',
    2: '.png, .pdf, .zip, .rar, .jpg, .jpeg',
    3: '.png, .pdf, .zip, .rar, .jpg, .jpeg',
    //4: '.docx',
    4: '.png, .pdf, .zip, .rar, .jpg, .jpeg, .docx',
    5: '.png, .pdf, .zip, .rar, .jpg, .jpeg',
    6: '.png, .pdf, .zip, .rar, .jpg, .jpeg',
  });

  useEffect(() => {
    //generatFileUpload()
    !isOpenDg && setInputValue('');
  }, [isOpenDg]);

  const onChangeUpload = (files) => {
    if (level === 6 || isEditPage) {
      files['fileOtherName'] = inputValue.trim();
    }
    let c = JSON.stringify(data);
    let copyData = [];
    copyData = [...JSON.parse(c)];
    if (Array.isArray(copyData)) {
      setTimeout(() => {
        copyData[level].content.fileUploaded = [...copyData[level].content.fileUploaded, files];
        setData(copyData);
        (isEditPage || level === 6) && setInputValue('');
      }, 10);
    }
  };
  const onDeleteItem = (item) => {
    let c = JSON.stringify(data);
    let copyData = [];
    copyData = [...JSON.parse(c)];
    if (Array.isArray(copyData)) {
      setTimeout(() => {
        copyData[level].content.fileUploaded = []
          .concat(...copyData[level].content.fileUploaded)
          .filter((a) => a.hash !== item.hash);
        setData(copyData);
      }, 10);
    }
  };
  return (
    <Dialog
      onClose={() => {
        !loadingUpload && setIsOpenDg(false);
      }}
      aria-labelledby="simple-dialog-title"
      fullWidth
      maxWidth="xs"
      open={isOpenDg}
      className={classes.dialogMain}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => {
          !loadingUpload && setIsOpenDg(false);
        }}
        className={classes.dialogTitle}
      >
        <span style={{ display: 'flex', fontSize: '14px' }}>
          {typeDg === 'ADD' ? (
            <>
              <Icons icon="UploadFile" color="#667585" hover="#667585" size="20" />
              <p style={{ marginRight: '4px' }}>{' بارگذاری ' + data?.[level]?.label}</p>
            </>
          ) : (
            <>
              <Icons icon="Edit" color="#667585" hover="#667585" size="20" />
              <p style={{ marginRight: '4px' }}>{' ویرایش ' + data?.[level]?.label}</p>
            </>
          )}
        </span>
       
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              !loadingUpload && setIsOpenDg(false);
            }}
            size="large">
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
      
      </DialogTitle>
      <DialogContent className={classes.content}>
        {
          <Grid container alignItems="center">
            <Grid style={{ position: 'relative', width: '100%' }}>
              <Grid md={12} xs={12} lg={12}>
                <Grid
                  style={{
                    fontSize: '12px',
                    marginBottom: '8px',
                    marginTop: '12px',
                    color: '#9AA6B1',
                  }}
                >
                  کاربر گرامی مدرک‌های خود را در محل‌های مشخص شده بارگذاری کنید.
                </Grid>

                {level === 4 && (
                  <Grid md={12} xs={12} lg={12}>
                    <Typography className={classes.bulkFileTitle}>
                      <a
                        className={classes.textFileExample}
                        href="/files/Digital_Account_Opening_Form.docx"
                        target="_blank"
                        rel="noreferrer"
                      >
                        دریافت فایل نمونه
                      </a>
                    </Typography>
                    <br />
                  </Grid>
                )}
                {(level === 6 || isEditPage) && (
                  <Grid md={12} xs={12} lg={12} className={classes.inpuTitleOther}>
                    <Typography className={classes.titleText}>
                      عنوان مدرک را وارد نمایید
                      <span style={{ color: '#ef5350', margin: '0px 8px 0 8px', fontSize: '14px' }}>
                        *
                      </span>
                    </Typography>
                    <InputV2
                      name="firstName"
                      // label="عنوان مدرک را وارد نمایید"
                      mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                      fullWidth
                      disabled={loadingUpload}
                      defaultValue={inputValue}
                      forceValue={inputValue}
                      onChangeValue={(v) => {
                        if (String(v?.target?.value).trim().length > 50) {
                          return;
                        }
                        setInputValue(String(v?.target?.value));
                      }}
                    />
                  </Grid>
                )}

                <Grid md={12} xs={12} lg={12}>
                  <UploadFiles
                    tooltip="فرمت فایل ارسالی به صورت jpg ,png ,pdf می‌باشد."
                    hasLink={true}
                    multiple={true}
                    setList={setFilesUpoaded}
                    type={'BUSINESS'}
                    data={data}
                    setData={setData}
                    list={data[level]?.content?.fileUploaded}
                    onChangeFile={onChangeUpload}
                    level={level}
                    onDeleteItem={onDeleteItem}
                    acceptsFile={acceptsFile[level]}
                    fileOtherName={inputValue}
                    setLoadingUpload={setLoadingUpload}
                    isEditPage={isEditPage}
                  />
                </Grid>

                <ButtonLoading
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ width: '100%', marginTop: '32px', marginBottom: '12px' }}
                  name="تایید "
                  disabled={loadingUpload}
                  onClick={() => {
                    if(isEditPage){

                      setUploaded(data[level]?.content?.fileUploaded);
                    }
                    setIsOpenDg(false);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        }
      </DialogContent>
    </Dialog>
  );
};

export default UploadFileDg;
